// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordStatus_container__3fkzl","status":"RecordStatus_status__2axdD","statusOnline":"RecordStatus_statusOnline__2a0bN"};